var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "editMemberTierModal",
      "modal-class": "client-details-modal payment-history",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "hide-header-close": "",
      "no-close-on-backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('h6', {
          staticClass: "mb-0"
        }, [_vm._v("Edit Tier")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', [_c('strong', [_vm._v("Choose Tier :")])]), _c('div', {
    staticClass: "col-12 mb-3 mt-2 tier-optionwrapper d-flex align-items-center gap-3"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tierType,
      expression: "tierType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "flexRadioDefault",
      "id": "flexRadioDefault1",
      "value": "IO"
    },
    domProps: {
      "checked": _vm._q(_vm.tierType, "IO")
    },
    on: {
      "change": function change($event) {
        _vm.tierType = "IO";
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "flexRadioDefault1"
    }
  }, [_vm._v(" IO ")])]), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tierType,
      expression: "tierType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "flexRadioDefault",
      "id": "flexRadioDefault2",
      "value": "IS"
    },
    domProps: {
      "checked": _vm._q(_vm.tierType, "IS")
    },
    on: {
      "change": function change($event) {
        _vm.tierType = "IS";
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "flexRadioDefault2"
    }
  }, [_vm._v(" IS ")])]), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tierType,
      expression: "tierType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "flexRadioDefault",
      "id": "flexRadioDefault3",
      "value": "IC"
    },
    domProps: {
      "checked": _vm._q(_vm.tierType, "IC")
    },
    on: {
      "change": function change($event) {
        _vm.tierType = "IC";
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "flexRadioDefault3"
    }
  }, [_vm._v(" IC ")])]), _c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.tierType,
      expression: "tierType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "name": "flexRadioDefault",
      "id": "flexRadioDefault4",
      "value": "IF"
    },
    domProps: {
      "checked": _vm._q(_vm.tierType, "IF")
    },
    on: {
      "change": function change($event) {
        _vm.tierType = "IF";
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "flexRadioDefault4"
    }
  }, [_vm._v(" IF ")])])])]), _vm.tierType === 'IS' ? _c('div', [_vm.spouses.length > 0 ? _c('div', {
    staticClass: "mb-3"
  }, _vm._l(_vm.spouses, function (sp, index) {
    return _c('div', {
      key: sp.id,
      staticClass: "d-inline-flex me-2  align-items-center gap-2 button_wrapper--blue mb-2"
    }, [_c('div', {
      staticClass: "rep_name d-inline-flex"
    }, [_vm._v(" #" + _vm._s(index + 1) + " " + _vm._s(sp.firstName) + " "), sp.middleName ? [_vm._v(" " + _vm._s(sp.middleName) + " ")] : _vm._e(), _vm._v(" " + _vm._s(sp.lastName) + " ")], 2), _c('button', {
      staticClass: "tier-listing-card-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editSpouse(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]);
  }), 0) : _vm._e(), _vm.spouses.length === 0 || _vm.editingSpouse ? _c('form', {
    staticClass: "tier-formwrapper mb-3"
  }, [_c('div', {
    staticClass: "form-titlewrapper"
  }, [_vm._v("Spouse Detail")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("First Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newSpouse.firstName,
      expression: "newSpouse.firstName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newSpouse.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newSpouse, "firstName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Middle Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newSpouse.middleName,
      expression: "newSpouse.middleName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Middle Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newSpouse.middleName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newSpouse, "middleName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Last Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newSpouse.lastName,
      expression: "newSpouse.lastName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newSpouse.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newSpouse, "lastName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Gender")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newSpouse.gender,
      expression: "newSpouse.gender"
    }],
    staticClass: "form-select mt-2",
    attrs: {
      "name": "gender",
      "id": "gender",
      "rules": {
        required: true
      }
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.newSpouse, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Gender")]), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _c('div', {
    staticClass: "col-md-6 col-lg-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Date of Birth")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newSpouse.dob,
      expression: "newSpouse.dob"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "date",
      "placeholder": "Select Date of Birth",
      "rules": {
        required: true
      },
      "max": new Date().toISOString().split('T')[0]
    },
    domProps: {
      "value": _vm.newSpouse.dob
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newSpouse, "dob", $event.target.value);
      }
    }
  })])])]) : _vm._e()]) : _vm._e(), _vm.tierType === 'IC' ? _c('div', [_vm.children.length > 0 ? _c('div', {
    staticClass: "mb-3"
  }, _vm._l(_vm.children, function (child, index) {
    return _c('div', {
      key: child.id,
      staticClass: "d-inline-flex align-items-center me-2 gap-2 button_wrapper--blue mb-2"
    }, [_c('div', {
      staticClass: "rep_name d-inline-flex"
    }, [_vm._v(" #" + _vm._s(index + 1) + " " + _vm._s(child.firstName) + " "), child.middleName ? [_vm._v(" " + _vm._s(child.middleName) + " ")] : _vm._e(), _vm._v(" " + _vm._s(child.lastName) + " ")], 2), _c('button', {
      staticClass: "tier-listing-card-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editChild(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('button', {
      staticClass: "tier-listing-card-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removeChild(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]);
  }), 0) : _vm._e(), _c('form', {
    staticClass: "tier-formwrapper mb-3"
  }, [_c('div', {
    staticClass: "form-titlewrapper"
  }, [_vm._v("Child Details")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("First Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newChild.firstName,
      expression: "newChild.firstName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newChild.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newChild, "firstName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Middle Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newChild.middleName,
      expression: "newChild.middleName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Middle Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newChild.middleName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newChild, "middleName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Last Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newChild.lastName,
      expression: "newChild.lastName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newChild.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newChild, "lastName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Gender")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newChild.gender,
      expression: "newChild.gender"
    }],
    staticClass: "form-select mt-2",
    attrs: {
      "name": "gender",
      "id": "gender",
      "rules": {
        required: true
      }
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.newChild, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Gender")]), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _c('div', {
    staticClass: "col-md-6 col-lg-6 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Date of Birth")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newChild.dob,
      expression: "newChild.dob"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "date",
      "placeholder": "Select Date of Birth",
      "rules": {
        required: true
      },
      "max": new Date().toISOString().split('T')[0]
    },
    domProps: {
      "value": _vm.newChild.dob
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newChild, "dob", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "addMore-btn mt-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addChild
    }
  }, [_vm.editingChildIndex !== null ? _c('span', [_vm._v("Update")]) : _c('span', [_vm._v("Add Child")])])])])]) : _vm._e(), _vm.tierType === 'IF' ? _c('div', [_vm.dependents.length > 0 ? _c('div', {
    staticClass: "mb-3"
  }, _vm._l(_vm.dependents, function (member, index) {
    return _c('div', {
      key: member.id,
      staticClass: "d-inline-flex me-2 align-items-center gap-2 button_wrapper--blue mb-2"
    }, [_c('div', {
      staticClass: "rep_name d-inline-flex"
    }, [_vm._v(" #" + _vm._s(index + 1) + " " + _vm._s(member.firstName) + " "), member.middleName ? [_vm._v(" " + _vm._s(member.middleName) + " ")] : _vm._e(), _vm._v(" " + _vm._s(member.lastName) + " "), _c('span', {
      staticClass: "rep_relation fw-normal"
    }, [_vm._v("(" + _vm._s(member.relation) + ")")])], 2), _c('button', {
      staticClass: "tier-listing-card-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editFamilyMember(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]), _c('button', {
      staticClass: "tier-listing-card-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removeFamilyMember(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]);
  }), 0) : _vm._e(), _c('form', {
    staticClass: "tier-formwrapper mb-3"
  }, [_c('div', {
    staticClass: "form-titlewrapper"
  }, [_vm._v("Family Details")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("First Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.firstName,
      expression: "newFamilyMember.firstName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter First Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newFamilyMember.firstName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newFamilyMember, "firstName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Middle Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.middleName,
      expression: "newFamilyMember.middleName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Middle Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newFamilyMember.middleName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newFamilyMember, "middleName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Last Name")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.lastName,
      expression: "newFamilyMember.lastName"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "text",
      "placeholder": "Enter Last Name",
      "rules": {
        required: true
      }
    },
    domProps: {
      "value": _vm.newFamilyMember.lastName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newFamilyMember, "lastName", $event.target.value);
      }
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Relation")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.relation,
      expression: "newFamilyMember.relation"
    }],
    staticClass: "form-select mt-2",
    attrs: {
      "name": "relation",
      "id": "relation",
      "rules": {
        required: true
      }
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.newFamilyMember, "relation", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Relation")]), _c('option', {
    attrs: {
      "value": "spouse",
      "disabled": _vm.spouses.length > 0
    }
  }, [_vm._v("Spouse")]), _c('option', {
    attrs: {
      "value": "child"
    }
  }, [_vm._v("Child")])])]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Gender")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.gender,
      expression: "newFamilyMember.gender"
    }],
    staticClass: "form-select mt-2",
    attrs: {
      "name": "gender",
      "id": "gender"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.newFamilyMember, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select Gender")]), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])])]), _c('div', {
    staticClass: "col-md-6 col-lg-4 mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Date of Birth")]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFamilyMember.dob,
      expression: "newFamilyMember.dob"
    }],
    staticClass: "input-field",
    attrs: {
      "type": "date",
      "placeholder": "Select Date of Birth",
      "rules": {
        required: true
      },
      "max": new Date().toISOString().split('T')[0]
    },
    domProps: {
      "value": _vm.newFamilyMember.dob
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.newFamilyMember, "dob", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "addMore-btn mt-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addFamilyMember
    }
  }, [_vm.editingFamilyMemberIndex !== null ? _c('span', [_vm._v("Update")]) : _c('span', [_vm._v("Add Family Member")])])])])]) : _vm._e(), _c('div', [_c('label', [_c('strong', [_vm._v("Reason ")])]), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.reasonText,
      expression: "reasonText"
    }],
    staticClass: "form-control mt-2",
    attrs: {
      "rows": "4",
      "placeholder": "Write a Reason"
    },
    domProps: {
      "value": _vm.reasonText
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.reasonText = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('button', {
    staticClass: "btn cancel-btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(" Save ")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }